import React, {Component} from 'react';
import {Button, MenuItem} from '@material-ui/core';
import {Booking} from 'services/entities/booking';
import {Design, DesignField} from 'services/entities/designs';
import {loadDesigns} from 'services/designs';
import SelectField from 'components/forms/SelectField';
import './index.scss';
import {updateBookingDesign} from 'services/bookings';
import {handleError} from 'util/errors';
import DesignThumbnail from 'components/designs/DesignThumbnail';
import ProgressSpinner from 'components/ProgressSpinner';

interface BookingDesignSelectorState {
  designs: Design[]|null;
  selectedDesign: string|null;
  saving: boolean;
}

interface BookingDesignSelectorProps {
  booking: Booking;
}

export default class BookingDesignSelector extends Component<BookingDesignSelectorProps, BookingDesignSelectorState> {
  state: BookingDesignSelectorState = {
    designs: null,
    selectedDesign: null,
    saving: false
  };

  componentDidMount(): void {
    loadDesigns({space: this.props.booking.space}, [DesignField.DesignScreenGroups, DesignField.ScreenGroups]).then(
      designs => this.setState({designs: designs})
    );
    this.setState({selectedDesign: this.props.booking.design});
  }

  onSelectedDesignChanged = (design: string) => {
    this.setState({selectedDesign: design});
  };

  onSaveClick = () => {
    this.setState({saving: true});
    updateBookingDesign(this.props.booking.code, this.state.selectedDesign!).then(
      () => this.setState({saving: false}),
      () => {
        this.setState({saving: false});
        handleError('Failed to update booking');
      }
    );
  };

  render() {
    const designs: Design[]|null = this.state.designs;
    const selectedDesignCode: string|null = this.state.selectedDesign;
    const selectedDesign = selectedDesignCode && designs ? designs!.find(des => des.code === selectedDesignCode) : null;
    const saving = this.state.saving;
    return <div className="booking-design-selector">
      <SelectField disabled={!designs || designs!.length === 0 || saving} onChange={this.onSelectedDesignChanged}
                   placeholder={designs && designs!.length === 0 ? 'No designs available' : undefined}
                    value={selectedDesignCode}>
        { designs && designs!.map(des => <MenuItem key={des.code} value={des.code}>{ des.name }</MenuItem>) }
      </SelectField>
      { selectedDesign && <div className="preview">
        <DesignThumbnail design={selectedDesign} />
      </div> }
      { saving
        ? <ProgressSpinner/>
        : <Button disabled={!selectedDesign} onClick={this.onSaveClick}>Save</Button> }
    </div>;
  }
}